import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import {
  getEntryCardData,
  AddAssetEntryCard,
  isValidXandrAccount,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useVideoCardContainerStyle } from '../../styles';

export const AssetsEntryCardContainer = ({
  i18n,
  aid,
  cid,
  oDataConfig,
  navigation,
  logger,
  permissions,
}) => {
  const classes = useVideoCardContainerStyle();
  const openSystemUploadRef = useRef(null);
  const isVideoTemplateEnabled = permissions && permissions.dynamic && permissions.dynamic.VideoTemplateUI;
  const isXandrIntEnabled = useMemo(() => permissions.dynamic.XandrIntegrationEnabled, [permissions]);
  // eslint-disable-next-line no-restricted-globals
  const { data: account } = useJsData(jsData => (isXandrIntEnabled ? jsData.Account.find(aid) : Promise.resolve()), [aid, isXandrIntEnabled]);
  const isXandrIntegrationEnabled = useMemo(() => (isXandrIntEnabled ? isValidXandrAccount(account) : false), [account, isXandrIntEnabled]);

  let cardKeys = isVideoTemplateEnabled ? ['Create', 'Upload', 'Website'] : ['Upload', 'Website'];

  if (isXandrIntegrationEnabled) {
    cardKeys = [...cardKeys, 'Invest'];
  }

  const cardData = getEntryCardData({
    i18n,
    isVideoPage: true,
    cardKeys,
    onClickCreate: () => {
      navigation.gotoVideoTemplatePage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickUpload: () => {
      openSystemUploadRef.current = {};
      navigation.gotoUploadFilesPanelPage({
        aid, cid, oDataConfig, i18n, mode: 'video', openSystemUpload: openSystemUploadRef.current,
      });
    },
    onClickWebsite: () => {
      if (logger && logger.logTrace) {
        logger.logTrace('Add video from URl');
      }
      navigation.gotoAddVideoPanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickInvest: () => {
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from invest');
      }
      navigation.gotoInvestVideoPanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    isXandrIntegrationEnabled,
  });

  return (
    <>
      <div className={classes.cardContainer}>
        {cardData.map(card => (
          <AddAssetEntryCard
            key={card.key}
            id={card.key}
            description={card.description}
            title={card.title}
            imageSrc={card.image}
            onClick={card.onClick}
            isFillWidth
          />
          ))}
      </div>
    </>
  );
};


AssetsEntryCardContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({
    gotoUploadFilesPanelPage: PropTypes.func,
    gotoAddVideoPanelPage: PropTypes.func,
    gotoInvestVideoPanelPage: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }),
};

AssetsEntryCardContainer.defaultProps = {
  permissions: { dynamic: {} },
};
